import { useCallback, useEffect } from 'react';
import Router from 'next/router';

import { useCookiesSettings } from 'app/providers/CookiesSettingsProvider';
import { BASE_ROUTES } from 'app/hooks/useUrl/useUrl';

import { HtmlHeader } from 'app/shared/components/HtmlHeader/HtmlHeader';
import { CookieSettings } from 'app/shared/components/CookieDashboard/CookieSettings/CookieSettings';
import { useTrackingPageContext } from 'app/shared/components/PageWrapper/providers/TrackingPageProvider/TrackingPageProvider';

const CookieDashboard = () => {
  const { trackAction } = useTrackingPageContext();
  const { saveCookieSettings, setHasSeenCookieConsent } = useCookiesSettings();

  const handleSave = useCallback(() => {
    trackAction('cookieDashboard_ctaButton_click', {
      description: 'user clicks on cookie dashboard cta button',
    });

    saveCookieSettings(true);

    Router.back();
  }, [saveCookieSettings, trackAction]);

  useEffect(() => {
    setHasSeenCookieConsent(true);

    return () => {
      setHasSeenCookieConsent(false);
    };
  }, []);

  return (
    <>
      <HtmlHeader title="Cookie Dashboard" path={BASE_ROUTES.cookiedashboard} />
      <CookieSettings onSave={handleSave} />
    </>
  );
};

export { CookieDashboard };
